export default "__VITE_ASSET__BjK$Uy5h__"